import { Calendar } from '@fullcalendar/core'
import dayGridPlugin from '@fullcalendar/daygrid'
// import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list'
import { WeekEventsList } from './ComponentEventsList'
import {
	dateToString,
	weekDays,
	WEEKEND_DAYS,
	WEEK_DAYS,
	WEEK_DAYS_NAMES,
	WEEK_DAYS_NAMES_SHORT,
} from './ComponentHelpers'
import Filters from './ComponentCalendarFilters'
const viewTypes = new Map([
	['view-default', 'dayGridMonth'],
	['view-list', 'listMonth'],
	['view-list-all', 'list'],
])

// window.addEventListener('load', () => {
const button = document.querySelector('[data-filters="toggle-visiblity"]')
if (button) {
	button.addEventListener('click', () => {
		const filtersBox = document.querySelector('[data-filters="filters-box"]')
		if (filtersBox) {
			filtersBox.classList.toggle('hidden')
		}
	})
}
const buttonMoreCategory = document.querySelector<HTMLElement>(
	'[data-filters="more-category"]'
)
if (buttonMoreCategory) {
	buttonMoreCategory.addEventListener('click', () => {
		const filtersMoreCategoryBox = document.querySelector(
			'[data-filters="more-category-box"]'
		)
		if (filtersMoreCategoryBox) {
			filtersMoreCategoryBox.classList.toggle('show')
			let txt = buttonMoreCategory.innerText
			buttonMoreCategory.innerText = txt == 'rozwiń' ? 'zwiń' : 'rozwiń'
		}
	})
}
// });

class CalendarView {
	container: HTMLElement
	url: string | null = ''
	eventDays: string[] = []
	currentWeek: string[] = []
	activeView: string | null = '';
	filtersForm: HTMLElement | null = null
	initialFetch: Boolean = true
	defaultView: string | null = '';
	calendar: Calendar | null = null;
	filters: Filters | null = null;

	constructor(container: HTMLElement, form: HTMLElement | null) {
		this.container = container
		this.url = container.getAttribute('data-fetch-url')
		this.eventDays = []
		this.currentWeek = []
		this.activeView = viewTypes.get('view-default') as string
		this.filtersForm = form
		this.initialFetch = true
		// this.filtersChanged;
		// this.filters = new Filters(form, this.filtersChanged.bind(this));

		this.defaultView = this.container.getAttribute('data-calendar-view-default')
		this.init()
		// this.fetchEvents(this.filters.getValues(this.calendar.getDate()));
	}

	init() {
		const d = new Date();
		let year = d.getFullYear();
		let getMonth = d.getMonth();
		let month = ''
		if (getMonth + 1 <= 9) {
			month = `0${getMonth + 1}`
		} else {
			month = `${getMonth + 1}`
		}

		this.calendar = new Calendar(this.container, {
			plugins: [dayGridPlugin, listPlugin],
			initialDate: `${year}-${month}-01`,
			// validRange: {
			// 	start: '2023-04-01',
			// 	end: '2023-06-01'
			// },
			initialView: this.activeView as string,
			locale: 'pl',
			headerToolbar: {
				start: '',
				center: 'prev,title,next',
				right: '',
				// right: 'today,prev,title,next',
			},
			// footerToolbar: {
			// 	start: '',
			// 	center: 'prev,title,next',
			// 	right: '',
			// },
			buttonText: {
				today: 'bieżący tydzień',
			},
			firstDay: 1,
			// dayHeaderContent: (e) => {
			// 	return WEEK_DAYS_NAMES_SHORT[e.date.getDay()]
			// },
			dayMaxEventRows: 1,
			events: [],
			dayCellContent: (e) => {
				return {
					html:
						'<div class="fc-daygrid-day-row d-flex align-items-baseline"><span class="fc-daygrid-day-number">' +
						e.date.getDate() +
						'</span><span class="fc-daygrid-day-day-name txt__beta d-none">' +
						WEEK_DAYS_NAMES_SHORT[e.date.getDay()] +
						'</span></div>',
				}
			},
			eventContent: function (arg, createElement) {
				if (arg.view.type === 'dayGridMonth') {
					if (arg.event.extendedProps.eventsListObj) {
						return {
							html: arg.event.extendedProps.eventsListObj.toElement(),
						}
					}
				} else {
					if (arg.event.extendedProps.eventsListObj) {
						return {
							html: arg.event.extendedProps.eventsListObj.eventObjects
								.map((ev: any) => ev.toListEvent())
								.join(''),
						}
					}
				}
				return ''
			},
			eventDidMount: (event) => {
				window.dispatchEvent(
					new CustomEvent(
						`bw-fc-event-mount-${dateToString(event.event.start)}`,
						{
							detail: {
								element: event.el,
							},
						}
					)
				)
				this.container.querySelectorAll('.fc-list-day').forEach((row) => {
					row.querySelectorAll('th').forEach((header) => {
						header.remove()
					})
				})
				if (event.view.type === 'listMonth' || event.view.type === 'list') {
					this.container.querySelectorAll('.fc-list-event').forEach((row) => {
						row.querySelectorAll('td').forEach((cell, index) => {
							if (index < 2) cell.remove()
						})
					})

					this.setListTableHeader()
				}
			},
			viewDidMount: () => {
				// this.addWeekButtons();
				this.updateHeight()
			},
			eventChange: () => {
				// this.addWeekButtons();
				this.updateHeight()
			},
			datesSet: () => {
				this.container.classList.add('loading')

				// let filter_value = this.filters ? this.filters.getValues() : ''
				let filter_value = ''

				if (this.defaultView) {

					if (
						viewTypes.has(this.defaultView) &&
						this.defaultView === 'view-list-all'
					) {
						this.fetchEvents(filter_value, this.defaultView)
					}
				} else {
					this.fetchEvents(filter_value)
				}

				this.addWeekButtons()
				this.updateHeight()
			},
		})
		// this.filters = new Filters(
		// 	this.filtersForm,
		// 	this.filtersChanged.bind(this),
		// 	this.calendar,
		// 	this.changeView.bind(this),
		// 	this.defaultView,
		// 	this.container
		// )

		this.calendar.render()


		this.updateHeight()
		window.addEventListener('resize', () => {
			this.updateHeight()
		})
		window.addEventListener('bw-expand-week', (e) => {
			setTimeout(() => {
				this.updateHeight()
			}, 100)
		})
		window.addEventListener('resize', () => {
			setTimeout(() => {
				this.updateHeight()
			}, 200)
		})
		this.setUpViewButtons()
		this.setUpViewDefault(this.defaultView as string)

	}
	setListTableHeader() {
		const headerRow = document.querySelector('.fc-list-table > thead > tr')
		if (headerRow) {
			headerRow.classList.add('list-row')
			headerRow.classList.add('list-row-header')
			// headerRow.innerHTML = `
			//             <div class="column-1 d-flex flex-column justify-content-center align-items-start">
			//                 <span class="txt__beta spacing__reset weight__regular lh__alfa color__alfa">
			//                 Tematyka
			//                 </span>
			//             </div>
			//             <div class="column-2 d-none d-lg-flex flex-column justify-content-center align-items-center">
			//                 <span class="txt__beta spacing__reset weight__regular lh__alfa color__alfa">
			//                 Data
			//                 </span>
			//             </div>
			//             <div class="column-3 d-flex flex-column justify-content-center align-items-start">
			//                 <span class="txt__beta spacing__reset weight__regular lh__alfa color__alfa">
			//                 Temat
			//                 </span>
			//             </div>
			//             <div class="column-4 d-flex flex-column justify-content-center align-items-start">
			//                 <span class="txt__beta spacing__reset weight__regular lh__alfa color__alfa">
			//                 Miejsce
			//                 </span>
			//             </div>
			//             <div class="column-5 d-flex flex-column justify-content-center align-items-start">
			//                <span class="txt__beta spacing__reset weight__regular lh__alfa color__alfa">
			//                 Prowadzący
			//                 </span>
			//             </div>
			//             <div class="d-none d-xl-flex column-6 column-5 flex-column justify-content-center align-items-center">
			//                <span class=" txt__beta spacing__reset weight__regular lh__alfa color__alfa">
			//                 Cena
			//                 </span>
			//             </div>
			//             <div class="column-7 d-flex flex-column justify-content-center align-items-center align-items-xl-end">
			//                 <span class="txt__beta spacing__reset weight__semi-bold lh__alfa color__alfa">
			//                 Kup
			//                 </span>
			//             </div>
			// `
		}
	}
	filtersChanged(params: any) {
		this.fetchEvents(params, null, 'filtersChanged')
		this.updateExpandedEvents()
	}
	setUpViewButtons() {
		const btnList = document.querySelectorAll('[data-calendar-view]')
		this.setActiveViewButton()
		btnList.forEach((btn) => {
			if (btn.getAttribute('data-calendar-view'))
				btn.addEventListener('click', (e) => {
					const viewAttr = btn.getAttribute('data-calendar-view') as string
					if (viewTypes.has(viewAttr)) {
						// this.calendar.changeView(viewTypes.get(viewAttr));
						// this.activeView = viewTypes.get(viewAttr);
						// this.setActiveViewButton();
						// this.updateExpandedEvents();

						this.changeView(viewAttr)
					}
				})
		})
	}
	changeView(viewAttr: string, dStart = null, dEnd = null) {
		if (this.calendar) {
			this.calendar.changeView(viewTypes.get(viewAttr) as string)
			this.activeView = viewTypes.get(viewAttr) as string
			this.setActiveViewButton()
			this.updateExpandedEvents()
			let dateStart = '2022-01-01'
			let dateEnd = '2033-12-31'
			if (dStart) {
				dateStart = dStart
			}
			if (dEnd) {
				dateEnd = dEnd
			}
			if (viewAttr === 'view-list-all') {
				this.calendar.setOption('visibleRange', {
					start: dateStart,
					end: dateEnd,
				})
			}
		}
	}
	setUpViewDefault(defaultView: string) {
		if (defaultView) {
			if (viewTypes.has(defaultView)) {
				// this.calendar.changeView(viewTypes.get(defaultView));

				// this.activeView = viewTypes.get(defaultView);
				// this.updateExpandedEvents();
				this.changeView(defaultView)
			}
		}
	}
	setActiveViewButton() {
		const btnList = document.querySelectorAll('[data-calendar-view]')
		btnList.forEach((btn) => {
			if (
				viewTypes.get(btn.getAttribute('data-calendar-view') as string) ===
				this.activeView
			) {
				btn.classList.add('active')
			} else {
				btn.classList.remove('active')
			}
		})
	}
	addWeekButtons() {
		if (this.calendar && this.calendar.view.type === 'dayGridMonth') {
			const table = this.calendar.el.querySelector('.fc-daygrid-body')
			const now = new Date()
			const currentWeek = weekDays(now)
			const nextWeek = weekDays(now.setDate(now.getDate() + 7))
			// if (table) {
			// 	table.querySelectorAll('tr').forEach((row) => {
			// 		const rowCell = row.querySelector('td')
			// 		const cells = row.querySelectorAll('td')
			// 		if (cells.length > 7) {
			// 			cells.forEach((cell, index) => {
			// 				if (index > 6) {
			// 					cell.remove()
			// 				}
			// 			})
			// 		}
			// 		const cell = document.createElement('td')
			// 		let date: string | null = ''
			// 		if (rowCell) {
			// 			date = rowCell.getAttribute('data-date')
			// 		}
			// 		if (currentWeek.includes(date)) {
			// 			cell.innerHTML = `<span class="current-week">Bieżący tydzień</span>`
			// 		} else if (nextWeek.includes(date)) {
			// 			cell.innerHTML = `<span class="next-week">następny tydzień</span>`
			// 		} else {
			// 			cell.innerHTML = `<button class="expand-week d-none" data-item="week-expand-btn" data-date="${date}"></button>`
			// 		}
			// 		row.appendChild(cell)
			// 	})
			// }
			this.updateExpandedEvents()
			if (table) {
				table.querySelectorAll('[data-item="week-expand-btn"]').forEach((btn) => {
					btn.addEventListener('click', (e) => {
						const date = btn.getAttribute('data-date')
						const week = weekDays(date)

						window.dispatchEvent(
							new CustomEvent('bw-expand-week-toggle', {
								detail: {
									dates: week,
								},
							})
						)
						btn.classList.contains('expanded')
							? btn.classList.remove('expanded')
							: btn.classList.add('expanded')
					})
				})
			}
		} else {
			this.container.querySelectorAll('.fc-list-day').forEach((row) => {
				row.querySelectorAll('th').forEach((header) => {
					header.remove()
				})
			})
		}
	}
	updateExpandedEvents() {
		const now = new Date()
		const currentWeek = weekDays(now)
		const nextWeek = weekDays(now.setDate(now.getDate() + 7))
		setTimeout(() => {
			window.dispatchEvent(
				new CustomEvent('bw-expand-week', {
					detail: {
						dates: [...currentWeek, ...nextWeek],
					},
				})
			)
		}, 400)
	}
	addEvents() {
		if (this.calendar) {
			this.calendar.removeAllEvents()
		}

		const newEventDays: any = {}
		for (const [key, value] of Object.entries(this.eventDays) as [string, any]) {
			// newEventDays[key] = []

			value.forEach((v: any) => {
				const alldDates = this.getDatesInRange(new Date(v['date']), new Date(v['date_end']));

				if (alldDates.length > 0) {
					alldDates.forEach((el, index) => {
						if (!newEventDays[el]) {
							newEventDays[el] = []
							console.log(el)
						}

						let newValue = JSON.parse(JSON.stringify(v));
						newValue['day'] = index + 1;
						// newEventDays[el] = newValue;
						newEventDays[el].push(newValue);
					})

				} else {
					if (!newEventDays[v['date']]) {
						newEventDays[v['date']] = []
					}
					newEventDays[v['date']].push(v);
				}
			})

			// const alldDates = this.getDatesInRange(new Date(value[0]['date']), new Date(value[0]['date_end']));

			// if (alldDates.length > 0) {
			// 	alldDates.forEach((el, index) => {
			// 		console.log(index)
			// 		let newValue = JSON.parse(JSON.stringify(value));
			// 		newValue[0]['day'] = index + 1;
			// 		newEventDays[el] = newValue;
			// 		// newEventDays[el][0]['day'] = index;
			// 		// newEventDays[el]['day'] = index;
			// 	})
			// } else {
			// 	newEventDays[key] = value;
			// }
		}
		// console.log(this.eventDays);
		// console.log(newEventDays);

		Object.keys(newEventDays).forEach((eventDay) => {

			const date = new Date(eventDay)
			let eventsList = new WeekEventsList(newEventDays[eventDay], eventDay)
			// if (WEEK_DAYS.includes(date.getDay())) {
			// 	eventsList = new WeekEventsList(newEventDays[eventDay], eventDay)
			// } else {
			// 	eventsList = new WeekendEventsList(newEventDays[eventDay], eventDay)
			// }
			this.calendar && this.calendar.addEvent(eventsList.toFcEvent())

		})

		this.updateHeight()
	}
	async fetchEvents(params: string | null = null, defaultView: string | null = null, error: string | null = null) {
		console.log(this.url)

		let fullUrl = `${this.url}date=${dateToString(this.calendar && this.calendar.getDate())}&${params ? params : this.filters && this.filters.getValues(this.calendar && this.calendar.getDate())
			}`
		if (defaultView === 'view-list-all') {
			fullUrl = `${this.url}date=&${params ? params : this.filters && this.filters.getValues()}`
		}
		const response = await fetch(`${fullUrl}`)
		const result = await response.json()

		if (result) {
			this.eventDays = result
			this.addEvents()
			this.container.classList.remove('loading')
		}
	}
	updateHeight() {
		let tableContainer: HTMLElement | null
		if (this.calendar && this.calendar.view.type === 'dayGridMonth') {
			tableContainer = this.container.querySelector('.fc-scrollgrid-sync-table')
		} else {
			tableContainer = this.container.querySelector('.fc-list-table')
		}
		const heightContainer = this.container.querySelector<HTMLElement>('.fc-view-harness')
		if (heightContainer && tableContainer) {
			heightContainer.style.height = `${tableContainer.offsetHeight + 30}px`
		}
	}
	getDatesInRange(startDate: any, endDate: any) {
		const date = new Date(startDate.getTime());

		const dates = [];

		while (date <= endDate) {
			let objectDate = new Date(date);


			let day = objectDate.getDate();

			let month = objectDate.getMonth();

			let year = objectDate.getFullYear();

			dates.push(`${year}-${month + 1}-${day}`);
			date.setDate(date.getDate() + 1);
		}

		return dates;
	}
}

// window.addEventListener('load', () => {
const calendarBox = document.querySelector<HTMLElement>('[data-calendar="container"]')
const filtersForm = document.querySelector<HTMLElement>('[data-calendar-filters="filters"]')
if (calendarBox) {
	const calendar = new CalendarView(calendarBox, filtersForm)
}
// });
